
<template>
  <div class="app-wrapper">
    <!-- 这里放置你的布局结构 -->
     
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AppLayout'
}
</script>

<style scoped>
.app-wrapper {
  height: 100%;
  width: 100%;
}
</style>